import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nonEnglish'
})
export class NonEnglishPipe implements PipeTransform {

  transform(str: string) {
    return str ? str.replace(/[^\w ]/g, '') : str;
  }
} 


// WEBPACK FOOTER //
// C:/Users/yanir/Desktop/workspace/TheBooksLibrary/src/app/pipes/non-english.pipe.ts